<template lang="pug">

  .register-shadow-component
    form(@submit.prevent='register', @keydown='form.onKeydown($event)', :class="{ 'has-errors': form.errors.any() }")
      registration-form(:form="form", shadow)
      .row
        .form-group.col-md-12.pt-4.no-check
          v-button.btn-default(:loading='form.busy', block='') {{ $t('register.submit') }}

    form-success-modal(:form="form")
      template(slot="title") An email has been sent to<br/>{{ this.resendForm.email }}
      template(slot="message") To complete your account registration, please click on the verification link sent to your email address. If you have not received an email, click the resend button below.
      template(slot="buttons")
        v-button.btn-primary(:loading="resendForm.busy", nativeType="button", @click="resendEmail()") Resend email »

    form-success-modal(:form="resendForm")
      template(slot="title") Success!
      template(slot="message") We have emailed verification link!
      template(slot="buttons")
        router-link.btn.btn-primary(:to="{ name: 'sign-in' }") Sign in

</template>

<script>
import Form from 'vform'
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'register-shadow',

  data: () => ({
    form: new Form({
      shadow_token: '',
      password: '',
      password_confirmation: '',
      address: '',
      city: '',
      state: '',
      postcode: '',
      phone: '',
      birthdate: ''
    }),
    resendForm: new Form({
      email: ''
    })
  }),

  methods: {
    async register () {
      this.form.shadow_token = this.shadowToken;
      this.form.preferred_location_id = this.form._preferred_location_id ? this.form._preferred_location_id.id : null;
      this.form.birthdate = moment(this.form.birthdate).format('YYYY-MM-DD');
      this.form.email_verification_path = window.config.pathMap.email_verification

      const { data } = await this.form.post(`${window.addiesaas.url}/api/register/shadow`);
      
      this.resendForm.email = data.email;
      this.form.reset();
    },

    async resendEmail () {
      await this.resendForm.post(`${window.addiesaas.url}/api/register/resend`);
    }
  },

  computed: {
    ...mapGetters({
      shadowToken: 'shadowToken'
    })
  },
}
</script>
